import { useState } from "react";
import { Modal, Button, Typography, Input, notification } from "antd";
import { CopyOutlined, ReloadOutlined, CheckOutlined } from "@ant-design/icons";
import { generatePassword } from "../utils/adminUtils";

const { Text } = Typography;

const ResetPasswordModal = ({
  user,
  isLoading,
  isOpen,
  onClose,
  onConfirm, // (newPassword, user_id) => void
}) => {
  const [password, setPassword] = useState(() => generatePassword());
  const [copied, setCopied] = useState(false);

  if (!user) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(password).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleRegenerate = () => {
    setPassword(generatePassword());
    setCopied(false);
  };

  const handleConfirm = () => {
    onConfirm(password, user.user_id);
  };

  return (
    <Modal
      title={`Reset Password - ${user.first_name} ${user.last_name}`}
      open={isOpen}
      onCancel={onClose}
      onOk={handleConfirm}
      okText="Reset Password"
      confirmLoading={isLoading}
      destroyOnClose
    >
      <div style={styles.wrapper}>
        <Text type="secondary" style={styles.hint}>
          A new password has been generated. Save or copy it before confirming -
          it will not be shown again.
        </Text>

        <div style={styles.passwordRow}>
          <Input
            value={password}
            readOnly
            style={styles.passwordInput}
            size="large"
          />
          <Button
            icon={copied ? <CheckOutlined /> : <CopyOutlined />}
            onClick={handleCopy}
            type={copied ? "primary" : "default"}
            size="large"
            title="Copy to clipboard"
          />
          <Button
            icon={<ReloadOutlined />}
            onClick={handleRegenerate}
            size="large"
            title="Regenerate"
          />
        </div>
      </div>
    </Modal>
  );
};

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "8px 0",
  },
  hint: {
    fontSize: 13,
  },
  passwordRow: {
    display: "flex",
    gap: 8,
    alignItems: "center",
  },
  passwordInput: {
    flex: 1,
    fontFamily: "monospace",
    fontWeight: 600,
    letterSpacing: "0.05em",
  },
};

export default ResetPasswordModal;